export default __webpack_public_path__ + "static/media/10 (1).bce52fbe.jpg";